import styled from "@yb/styled-px2rem";

const Wrap = styled.div`
	position: relative;
	min-height: 300px;
`;

const Box = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 20px;
	transform: translate(-50%, -50%);

	div {
		display: flex;
		gap: 5px;
	}

	span {
		position: relative;
		display: inline-block;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: #fcdc29;
		animation: loading 1.5s linear infinite;

		&:nth-child(1) {
			animation-delay: 0.1s;
		}
		&:nth-child(2) {
			animation-delay: 0.2s;
		}
		&:nth-child(3) {
			animation-delay: 0.3s;
		}
		&:nth-child(4) {
			animation-delay: 0.4s;
		}
		&:nth-child(5) {
			animation-delay: 0.5s;
		}
		&:nth-child(6) {
			animation-delay: 0.6s;
		}
	}

	@keyframes loading {
		0% {
			transform: translateY(0px) rotate(45deg);
			background-color: #ddd;
		}

		50% {
			transform: translateY(-20px) rotate(45deg);
			background-color: #ddd;
			opacity: 0;
		}
		100% {
			transform: translateY(0px) rotate(45deg);
			background-color: #ffc72c;
			border-bottom-right-radius: 0;
		}
	}
`;

const Text = styled.p`
	text-align: center;

	em {
		color: var(--yellow-color);
	}
`;

const LoadingBox = props => {
	const {children} = props;

	return (
		<Wrap>
			<Box>
				<div>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<Text>{children}</Text>
			</Box>
		</Wrap>
	);
};

export default LoadingBox;
